import {
  Injectable,
  Injector,
  ComponentFactoryResolver,
  EmbeddedViewRef,
  ApplicationRef
} from '@angular/core';
import { ToasterALV1Component } from './toaster-al-v1.component';
import { TosterData, TosterOption } from './toaster';
declare let $: any;
@Injectable()
export class ToasterALV1Service {
  public toasterRef: any = null;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) { }

  show(data: TosterData, options: TosterOption = { top: '8vh' }, afterClose = (val?) => {}, isToasterALV2: boolean = false) {
    // create a component reference from the component 
    const componentRef = this.componentFactoryResolver
      .resolveComponentFactory(ToasterALV1Component)
      .create(this.injector);
    const autoCloseTime = data.autoCloseTime || 0;
    // pass data
    componentRef.instance.data = data;
    componentRef.instance.options = options;
    componentRef.instance.isToasterALV2 = isToasterALV2;
    this.toasterRef = {
      ref: componentRef,
      close: (shouldCallAfterCloseCallbackFn = false) => {
        closeToast(shouldCallAfterCloseCallbackFn);
      }
    }
    const prevElement = data.prevIdToFocus ? $(`#${data.prevIdToFocus}`) : null;
    // open modal after miliseconds
    setTimeout(() => {
      componentRef.instance.isOpen = true;
    })
    let autoCloseTimer: any;
    // auto close modal after miliseconds
    if(autoCloseTime) {
     autoCloseTimer = setTimeout(() => {
        closeToast(true);
      }, autoCloseTime);
    }

    const closeToast = (shouldCallAfterCloseCallbackFn) => {
       if (autoCloseTimer) {
          clearTimeout(autoCloseTimer); // cancel auto-close
        }
      componentRef.instance.isOpen = false;
      this.appRef.detachView(componentRef.hostView);
     shouldCallAfterCloseCallbackFn && afterClose && afterClose();
      if (prevElement && prevElement.length) {
        setTimeout(() => prevElement.focus(), 0);
      }
      componentRef.destroy();
    }

    // close on click
    componentRef.instance.closeToaster.subscribe(val => {
       if (autoCloseTimer) {
          clearTimeout(autoCloseTimer); // cancel auto-close
        }
      this.appRef.detachView(componentRef.hostView);
      val?.shouldCallCallback && afterClose && afterClose(val?.callBackAction);
      if (prevElement && prevElement.length) {
        setTimeout(() => prevElement.focus(), 0);
      }
      componentRef.destroy();
    });
    // Attach component to the appRef so that it's inside the ng component tree
    this.appRef.attachView(componentRef.hostView);

    // Get DOM element from component
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    // Append DOM element to the body
    document.body.appendChild(domElem);
  }
}
